module.exports = __webpack_public_path__ + "img/map-menu-0@2x.7c432fef.png";